"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onElementHeightChange = void 0;

var onElementHeightChange = function onElementHeightChange(elm, callback) {
  var newHeight;
  var lastHeight = elm.clientHeight;

  (function run() {
    newHeight = elm.clientHeight;
    if (lastHeight !== newHeight) callback(newHeight);
    lastHeight = newHeight;
    if (elm.onElementHeightChangeTimer) clearTimeout(elm.onElementHeightChangeTimer); // eslint-disable-next-line no-param-reassign

    elm.onElementHeightChangeTimer = setTimeout(run, 0);
  })();
};

exports.onElementHeightChange = onElementHeightChange;